export default __webpack_public_path__ + "static/frog-checkout-d49a922e6bed0ca55d10e307632d0bc7.png";